module.exports = __webpack_public_path__ + "static/media/FattyPay.23d8c783.svg";